
import Checklist from 'vux/src/components/checklist/index.vue'

export default {
data(){
return{
options:[],
value:[],
cloums:{}
}
},
props: {
data: {
type: Object,
default: {

},
immediate:true
},
index:{
type: Number,
default: {

},
}
},
watch:{
data:{
handler(newval,oldvalue) {

this.cloums = newval;
this.options = [];
for(let i =0;i<newval.choices.options.length;i++){
this.options.push(newval.choices.options[i])
this.options[i].key = newval.choices.options[i].id;
this.options[i].value = newval.choices.options[i].optionContent;
}
},
immediate:true
}
},
components: {
Checklist
},
methods:{
change(value, label){
if(value.length !=0){

this.cloums.answer = value.toString();
this.cloums.choices.answer =  value.toString();
}else{
this.cloums.answer = '';
this.cloums.choices.answer = '';
}
this.$emit('change',{value:value,cloums:this.cloums,index:this.index})
}
},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/components/questionnaireTempelet/chooseTempelet.vue